<template>
  <div class="text-left">
    <h5 class="text-center">
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <row-col-select-one-field
          v-model="stay.person"
          data-source="person"
          :label="$t('form.person_stay')"
          :required="true"
        />

        <v-row>
          <col-date-field
            v-model="stay.start_date"
            :label="$t('form.date_start')"
          />
          <col-date-field 
            v-model="stay.end_date"
            :label="$t('form.date_end')"
          />
        </v-row>

        <row-col-radio-horizontal-field
          v-model="stay.type"
          :label="$t('form.stay_type')"
          :options="[
            { text: $t('form.stay_predoc'), value: 'predoc' },
            { text: $t('form.stay_posdoc'), value: 'posdoc' },
            { text: $t('form.stay_other'), value: 'other' }
          ]"
          :required="true"
        />

        <row-col-select-one-field
          v-model="stay.organization"
          data-source="organization"
          :label="$t('form.organization_stay')"
          :required="true"
          :allow-custom-value="true"
        />

        <row-col-text-field
          v-model="stay.responsible"
          :label="$t('form.responsible')"
        />

        <row-col-text-area-field
          v-model="stay.description"
          :label="$t('form.description_stay')"
        />

        <row-col-select-one-field
          v-model="stay.funder_program"
          data-source="funder_program"
          :label="$t('form.funder_program_stay')"
        />

        <row-col-text-area-field
          v-model="stay.funding_comments"
          :label="$t('form.funding_comments')"
        />

        <v-divider />

        <DirectorActions
          v-if="isAuthorize"
          :object_type="object_type"
          class="text-center"
        />
        <SupervisorActions
          v-else
          :item="stay"
          :object_type="object_type"
          :form_name="form_name"
          :state="state"
          :supervisor="supervisor !== null ? supervisor.username : ''"
          @change-state-supervisor="onStateSupervisorChange"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import stay_data from "@/mixins/stay_data";
import stay_model from "@/mixins/model_utils/stay_model";
import ColDateField from "../../reusables/ColDateField";
import RowColTextAreaField from "../../reusables/RowColTextAreaField";
import RowColTextField from "../../reusables/RowColTextField";
import RowColSelectOneField from "../../reusables/RowColSelectOneField";
import RowColRadioHorizontalField from "@/components/reusables/RowColRadioHorizontalField.vue";


export default {
  mixins: [stay_data, stay_model],
  components: {
    DirectorActions,
    SupervisorActions,
    ColDateField,
    RowColTextAreaField,
    RowColSelectOneField,
    RowColRadioHorizontalField,
    RowColTextField
  },

  data: () => ({
    form_name: "reviewStayForms",
    load_complete: false,
    state: "",
    title: "",
    reject_comment: "",
    object_id: null,
    object_type: "news",
    supervisor: "",
    people: [],
    organizations: [],
  }),

  watch: {
    stay: {
      handler() {
        this.updateTitle();
      },
      deep: true
    },
    people() {
      this.updateTitle();
    },
    organizations() {
      this.updateTitle();
    }
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  created() {
    axios.get(this.$store.state.endpoint + "/personName")
      .then(response => {
        this.people = response.data;
        this.updateTitle();
      })
      .catch(error => {
          console.error(error);
      });
    axios.get(this.$store.state.endpoint + "/organization")
      .then(response => {
        this.organizations = response.data;
        this.updateTitle();
      })
      .catch(error => {
          console.error(error);
      });
    this.getData();
  },

  methods: {
    resolveOrganizationLabel(value) {
      if (!value) {
        return "";
      }
      if (typeof value === "string") {
        return value;
      }
      if (typeof value === "object") {
        if (value.name) {
          return value.name;
        }
        if (value.title) {
          return value.title;
        }
        if (value.id !== undefined && value.id !== null) {
          const match = this.organizations.find(org => org.id === value.id);
          return match ? match.name : "";
        }
        return "";
      }
      const match = this.organizations.find(org => org.id === value);
      return match ? match.name : "";
    },
    resolvePersonLabel(personId) {
      if (!personId) {
        return "";
      }
      const person = this.people.find(item => item.id === personId);
      if (!person) {
        return "";
      }
      const { preferred_name } = person;
      return `${preferred_name.given_name} ${preferred_name.family_name}`.trim();
    },
    updateTitle(stayData = this.stay) {
      if (!stayData) {
        this.title = "";
        return;
      }
      const personLabel = this.resolvePersonLabel(stayData.person);
      const organizationLabel = this.resolveOrganizationLabel(stayData.organization);
      this.title = personLabel && organizationLabel ? `${personLabel} - ${organizationLabel}` : personLabel || organizationLabel || "";
    },
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/stay/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.stay = response.data.data.user.stay;
          this.updateTitle(this.stay);
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.stay.id = response.data.object_id;
          this.form_name = response.data.form_name;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
